import type { ReactElement } from 'react';

import { Select } from '@/components/ui/select';
import { COUNTRIES, normalizeCountry } from '@/lib/countries';

interface CountrySelectProps {
  readonly value: string | null;
  readonly placeholder: string;
  readonly onChange: (next: string | null) => void;
}

export function CountrySelect({
  value,
  placeholder,
  onChange,
}: CountrySelectProps): ReactElement {
  const normalized = normalizeCountry(value);
  const known = COUNTRIES.some((c) => c.code === normalized);
  const selectValue = normalized ?? '';

  return (
    <Select
      value={selectValue}
      className="h-8 text-sm"
      onChange={(event) => {
        const next = event.target.value;
        onChange(next.length > 0 ? next : null);
      }}
    >
      <option value="">{placeholder}</option>
      {!known && normalized !== null && (
        <option value={normalized}>{normalized}</option>
      )}
      {COUNTRIES.map((country) => (
        <option key={country.code} value={country.code}>
          {country.name}
        </option>
      ))}
    </Select>
  );
}
